import { styled } from 'styled-components';

import SmallButton from '@src/components/styled/SmallButton';

const Container = styled.div`
  display: flex;
  flex-direction: row;
  flex-wrap: wrap;
  align-items: center;
  justify-content: space-between;

  border: 2pt solid gray;
  padding: 5pt;
  margin-bottom: 5pt;

  // color hyperlink blue
  color: #0000ff;

  //background color windows 98 gray
  background-color: #c0c0c0;

  overflow-x: clip;
  
  -khtml-user-select: none;
  -o-user-select: none;
  -moz-user-select: none;
  -webkit-user-select: none;

  @media only screen and (max-width: 720px) {
    justify-content: center;
    align-items: center;
    align-text: center;
    text-align: center;

    padding: 5pt;
  }

  a {
    flex-grow: 1;
    display: flex;
    // margin-right: 10pt;
    font-size: 2rem;
  }

  div {
    // debug border
    // box-sizing: border-box;
    // -moz-box-sizing: border-box;
    // -webkit-box-sizing: border-box;
    // border: 1pt solid blue;

    @media only screen and (max-width: 720px) {
      flex: 1;
      min-width: 50%;
      max-width: 100%;
      font-size: 1.5rem;
      margin-top: 5pt;
    }
  }

  button {
    @media only screen and (max-width: 720px) {
      margin-top: 5pt;
    }
  }
`;

const GameName = styled.div`
  font-size: 2rem;

  min-width: 18rem;
  max-width: 18rem;
  white-space: nowrap;
  overflow: hidden;
  text-overflow: ellipsis;
`;

const IsPublic = styled.div<{ isPublic: boolean }>`
  font-size: 2rem;

  min-width: 7rem;
  max-width: 7rem;

  text-align: center;

  color: ${(props) => (props.isPublic ? 'green' : 'red')};
`;

const Started = styled.div<{ gameStarted: boolean }>`
  font-size: 2rem;

  min-width: 7rem;
  max-width: 7rem;

  text-align: center;

  color: ${(props) => (props.gameStarted ? '#eb6b34' : 'green')};
`;

const Players = styled.div`
  font-size: 2rem;

  min-width: 7rem;
  max-width: 7rem;

  text-align: center;
`;

const Host = styled.div`
  font-size: 2rem;

  min-width: 7rem;
  max-width: 7rem;

  text-align: center;

`;

const DMT = styled.div`
  font-size: 2rem;

  min-width: 4.5rem;
  max-width: 4.5rem;

  text-align: center;

  color: black;
`;

const ButtonContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: space-around;
  align-items: center;

  min-width: 7rem;
  max-width: 7rem;

  button {
    margin-top: 5pt;
  }

  @media only screen and (max-width: 820px) {
    flex-direction: row;
    min-width: 7rem;
    max-width: 10rem;
  }
`;

// const ColorSpan = styled.span<{ color?: string }>`
//   color: ${(props) => props.color || 'black'};
// `;

type Props = {
  name: string;
  gameId: string;
  numPlayers: number;
  maxPlayers: number;
  isPublic: boolean;
  gameStarted: boolean;
  gameWager: number;
  gameHost: string;
  gameType: string;
  playerCanJoin: boolean;
  joinGame: (gameId: string, gameName: string, gameWager: number) => void;
  watchGame: (gameId: string) => void;
  showJoinPrivateGamePanel: (
    gameId: string,
    gameName: string,
    gameWager: number,
  ) => void;
};

export default function Row(props: Props) {
  const joinGame = (gameId: string, gameName: string, gameWager: number) => {
    if (!props.isPublic)
      return props.showJoinPrivateGamePanel(gameId, gameName, gameWager);
    props.joinGame(gameId, gameName, gameWager);
  };

  return (
    <Container>
      <GameName>{props.name}</GameName>
      <Host>host: {props.gameHost}</Host>
      <IsPublic isPublic={props.isPublic}>
        {props.isPublic ? 'public' : 'private'}
      </IsPublic>
      <DMT>{props.gameWager} $GOLD</DMT>
      <Started gameStarted={props.gameStarted}>
        {props.gameStarted ? 'started' : 'not started'}
      </Started>
      <Players>
        players: {props.numPlayers}/{props.maxPlayers}
      </Players>
      <ButtonContainer>
        <SmallButton
          onClick={() => joinGame(props.gameId, props.name, props.gameWager)}
          disabled={props.gameType === 'tournament' && !props.playerCanJoin}
        >
          JOIN
        </SmallButton>
        {props.gameStarted && props.isPublic && (
          <SmallButton onClick={() => props.watchGame(props.gameId)}>
            VIEW
          </SmallButton>
        )}
      </ButtonContainer>
    </Container>
  );
}
